// HTTP client for the extraction endpoint. One call, one complete answer.
//
// The endpoint is a Lambda Function URL owned by Longview-Api. It holds the
// model credential and does nothing else - it does not own the loop, the
// timing, or the state (spec s5.3). The browser drives.

import type { ChecklistConfig } from '../config/types';
import { endpoints } from '../config/endpoints';

export type ExtractionUsage = {
  inputTokens: number;
  outputTokens: number;
  costUsd: number;
};

export type ExtractionResponse = {
  fields: unknown;
  model: string;
  latencyMs: number;
  usage: ExtractionUsage;
};

export async function requestExtraction(
  config: ChecklistConfig,
  transcript: string,
  signal?: AbortSignal,
): Promise<ExtractionResponse> {
  if (!endpoints.extract) {
    throw new Error('VITE_EXTRACT_URL is not set in this build.');
  }

  const response = await fetch(endpoints.extract, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      checklistName: config.name,
      fields: config.fields,
      transcript,
    }),
    signal,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error ?? `extraction failed (${response.status})`);
  }

  const body = await response.json();
  return {
    fields: { fields: body.fields },
    model: body.model,
    latencyMs: body.latencyMs,
    usage: body.usage ?? { inputTokens: 0, outputTokens: 0, costUsd: 0 },
  };
}
